export const SET_PRODUCERS_LIST = 'SET_PRODUCERS_LIST';
export const SET_All_PRODUCERS_LIST = 'SET_All_PRODUCERS_LIST';
export const SET_LOADING = 'SET_LOADING';
